import { ContextWrapper } from "config/context";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { AppRoutes } from "routes";

function App() {
  return (
    <ContextWrapper>
      <ToastContainer
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover
        theme='light'
      />
      <AppRoutes />
    </ContextWrapper>
  );
}

export default App;
